// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3EH9u","footer":"ReportModalFilter_footer__1CVwJ"};